<template>
    <div v-if="errMessage" class="barco-img align-center" style="width: 80%;height: inherit">
        <span class="dp-block b">{{ errMessage }}</span>
    </div>  
    <div v-else class="dp-flex flex-column" style="position: relative">
        <div class="dp-flex flex-between" v-if="idBarcode !== '' || idDreamBarcode !== ''">
            <div class="tab-menu">
                <ul>
                    <li @click="barcodeTab = 'discount'" class="tablink" :class="{ 'active': barcodeTab === 'discount' }">
                        <a class="a-tab" style="font-size: 16px">{{ $t('사원_카드') }}</a>
                    </li>
                    <li @click="barcodeTab = 'gift'" class="tablink" :class="{ 'active': barcodeTab === 'gift' }">
                        <a class="a-tab" style="font-size: 16px">{{ $t('드림_카드') }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="space-m"></div>
        <LoadingBar v-if="isLoading" />
        <div id="barcode" class="barco-img" v-show="!isLoading"></div>
    </div>
</template>

<script>
import LoadingBar from '@appbase/components/loading/LoadingBar.vue'
import api from '@appbase/api'

export default {
    data() {
        return {
            isLoading: true,
            errMessage: '',
            barcodeTab: 'discount',
            idBarcode: '',
            idDreamBarcode: ''
        }
    },
    components: { LoadingBar },
    props: {
        personId: String,
    },
    watch: {
        barcodeTab: function(newTab) {
            if(newTab == 'discount') {
                $('#barcode').barcode(this.idBarcode, 'code128', {showHRI:false, color:'#000', output: 'svg'});
            } else {
                $('#barcode').barcode(this.idDreamBarcode, 'code128', {showHRI:false, color:'#000', output: 'svg'});
            }
            
            this.$emit('change', newTab);
        }
    },
    mounted() {
        this.isLoading = true
        api.usercard.getUserBarcode().then(res=>{
            if(res !== null){
                var result = JSON.parse(res);
                if(result.data){
                    this.idBarcode = result.data.idBarcode;
                    this.idDreamBarcode = result.data.idDreamBarcode;
                    $('#barcode').barcode(this.idBarcode, 'code128', {showHRI:false, color:'#000', output: 'svg'});
                } else {
                    this.errMessage = result.detailMessage;
                }
                this.$emit('change', this.barcodeTab);
            }
            else{
                this.idBarcode = '';
                this.idDreamBarcode = '';
                this.errMessage = '통신에러';
            }
        }).finally(()=>{
            this.isLoading = false
        })
    }
}
</script>